/**
 * Utility functions for class name handling.
 * 
 * Used by shadcn/ui components.
 */

import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge class names with Tailwind CSS.
 * 
 * Handles conditional classes and resolves Tailwind conflicts.
 * 
 * @param inputs - Class names to merge
 * @returns Merged class string
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
